import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';

/* MVP need mor time for make PLUGIN */
$(document).ready(function () {
    let imagePopup = $('.image-popup');
    if (imagePopup.length) {
        imagePopup.magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true
            }
        });
    }
})